export default __webpack_public_path__ + "static/media/cp_geo_gp.3b415faf.svg";